import React, { useEffect, useState } from 'react';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Container } from '../../../../symphony';

import { IFlashMessage } from '../../global-interface';
import { SlLEContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { SlFlashMessage } from '../../../../shared/public/SlFlashMessage/SlFlashMessage';

import s from './FlashMessage.scss';

export function FlashMessage(): JSX.Element {
	useStyles(s);
	const { flashMessage$ } = Container.take(SlLEContext, SlDataService);
	const [flashMessage, setFlashMessage] = useState<IFlashMessage>(null);

	useEffect(() => {
		const unsubscriber = new Subject<void>();

		flashMessage$
			.pipe(
				filter((m) => !!m),
				takeUntil(unsubscriber),
			)
			.subscribe((data) => {
				setFlashMessage(data);
			});

		return () => {
			unsubscriber.next();
			unsubscriber.complete();
		};
	}, []);

	const didClosed = () => {
		flashMessage$.next(null);
		setFlashMessage(null);
	};

	const onClose = () => {
		flashMessage$.next(null);
		setFlashMessage(null);
	};

	return flashMessage ? (
		<div>
			<SlFlashMessage
				data={{ ...flashMessage }}
				didClosed={didClosed}
				onClose={onClose}
			/>
		</div>
	) : null;
}
